import { render, staticRenderFns } from "./FavModal.vue?vue&type=template&id=9236b116&scoped=true"
import script from "./FavModal.vue?vue&type=script&lang=js"
export * from "./FavModal.vue?vue&type=script&lang=js"
import style0 from "./FavModal.vue?vue&type=style&index=0&id=9236b116&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9236b116",
  null
  
)

export default component.exports